<div [ngClass]="containerClasses()" [ngStyle]="containerStyles()">
  <div class="so-card__content">
    <ng-content></ng-content>
  </div>
</div>
